import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { BuildingSelectFormikField } from '../../../../Building'
import { FLAT_FORM_FIELD_NAME_BUILDING } from '../../FlatForm.constants'

function BuildingField({ apiParams }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <BuildingSelectFormikField
      apiParams={apiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Flat.BuildingPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Flat.BuildingLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      name={FLAT_FORM_FIELD_NAME_BUILDING}
    />
  )
}

export default BuildingField
